import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ProjectSettingsPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "ProjectSettingsPopup" */ './Container'),
  'popup'
);
